/**************************************************
 * Nombre:       Tarjeta_Antes_Despues
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import punto from '../../Recursos/Iconos/ic_punto.svg'
import check from '../../Recursos/Iconos/ic_check.svg'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Antes_Despues = ({antes = true, titulo = '', lista = []}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: antes ? '#F7F3FE' : '#16082E',
                borderRadius: 8,
                border: 1,
                borderColor: '#E3D9F7',
                p: 4

            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{
                    color: antes ? '#1B0B3B50' : '#39E8FF',
                    fontSize: sCell ? 24 : 28,
                    fontWeight: 600,
                    textTransform: 'uppercase'
                }}>
                    {titulo}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 2}}
            >

                {lista.map((it, index) => (
                    <Typography sx={{
                        border: 1,
                        borderStyle: 'dashed',
                        borderColor: antes ? '#897F9C' : '#39E8FF',
                        color: '#897F9C',
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        fontSize: sCell ? 12 : 16
                    }}>
                        <img src={antes ? punto : check} width={antes ? 7 : 10} height={'auto'}
                             style={{marginTop: antes ? -2 : 0, marginBottom: antes ? 2 : 0, marginRight: 4}}/>
                        {it}
                    </Typography>
                ))}

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Antes_Despues


const items = ['Rentable', 'Mejor Retencion', 'Habilidades Unicas', 'Liderezgo', 'Mejores Ganancias']